import React from "react";
import { useTranslation } from "react-i18next";
import CreatableSelect from "react-select/creatable";
import NamespaceFilter from "./NamespaceFilter";
import { Card, Col, Row } from "react-bootstrap";
import StartVectorization from "../ConfirmStartButtons/StartVectorization";
import { useLoadOptions } from "../../hooks/useLoadOptions";
import { FetchOptionType, IOptionType } from "../../types/common";
import MetadataFilterCard from "./MetadataFilterCard";
import { IMatchModel } from "../../types/pinecone";
import StartImageGeneration from "../ConfirmStartButtons/StartImageGeneration";
import { useAuthorization } from "../../hooks";

interface IImageMatcherActionCardProps {
    isLoading: boolean;
    selectedNameSpace: string;
    setSelectedNameSpace: (namespace: string) => void;
    selectedItemGroups: IOptionType[];
    setSelectedItemGroups: (groups: IOptionType[]) => void;
    selectedManufacturers: IOptionType[];
    setSelectedManufacturers: (manufacturers: IOptionType[]) => void;
    imageFileObject?: File | null;
    pineconeMatches: IMatchModel[];
    setMetadata: (metadata: Record<string, { $in: string[] }>) => void;
    imageId: string;
}

const ImageMatcherActionCard: React.FC<IImageMatcherActionCardProps> = ({
    isLoading,
    selectedNameSpace,
    setSelectedNameSpace,
    selectedItemGroups,
    setSelectedItemGroups,
    selectedManufacturers,
    setSelectedManufacturers,
    imageFileObject,
    setMetadata,
    pineconeMatches,
    imageId,
}) => {
    const { t } = useTranslation();
    const {hasVectorizationPermission, hasImageGenerationPermission} = useAuthorization();

    const {
        manufacturerOptions,
        itemGroupOptions
    } = useLoadOptions([FetchOptionType.Manufacturer, FetchOptionType.ItemGroups]);

    return (
        <Card>
            <Card.Body className="d-flex flex-column gap-2">
                <Row>
                    <Col md={6}>
                        <NamespaceFilter
                            namespace={selectedNameSpace}
                            setNamespace={setSelectedNameSpace}
                            isLoading={isLoading}
                        />
                    </Col>
                    {imageFileObject && (hasVectorizationPermission || hasImageGenerationPermission) && (
                        <Col md={6}>
                            <StartVectorization uploadedFile={imageFileObject} />
                            <StartImageGeneration imageId={imageId} pineconeMatches={pineconeMatches} />
                        </Col>
                    )}
                </Row>
                {selectedNameSpace === "BtlSingle" || selectedNameSpace === "BtlAll" ?
                    <></>
                    :
                    <CreatableSelect
                        className="border-0 d-md-block"
                        closeMenuOnSelect={false}
                        isMulti
                        options={itemGroupOptions}
                        value={selectedItemGroups}
                        placeholder={t("Filter.itemgroup")}
                        isSearchable
                        onChange={(choice) => setSelectedItemGroups(choice as IOptionType[])}
                        isDisabled={isLoading}
                    />
                }

                <CreatableSelect
                    className="border-0 d-md-block"
                    closeMenuOnSelect={false}
                    isMulti
                    options={manufacturerOptions}
                    value={selectedManufacturers}
                    placeholder={t("Filter.manufacturer")}
                    isSearchable
                    onChange={(choice) => setSelectedManufacturers(choice as IOptionType[])}
                    isDisabled={isLoading}
                />
                <MetadataFilterCard pineconeMatches={pineconeMatches} setMetadata={setMetadata} />
            </Card.Body>
        </Card>
    );
};

export default ImageMatcherActionCard;